import { render } from "./Sketch_guangdong.vue?vue&type=template&id=59244132&scoped=true&ts=true"
import script from "./Sketch_guangdong.vue?vue&type=script&lang=ts"
export * from "./Sketch_guangdong.vue?vue&type=script&lang=ts"

import "./Sketch_guangdong.vue?vue&type=style&index=0&id=59244132&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59244132"]])

export default __exports__